import { PERMISSION_LABELS } from '../../../utils/adminPermissions'

// Inline banner shown above a section when the admin can view but not change it.
export function ReadOnlyBanner({ permission, className = '' }) {
  const label = PERMISSION_LABELS[permission] ?? permission
  return (
    <div
      role="status"
      className={`flex items-start gap-3 border-[3px] border-on-background/30 bg-surface-container-low p-3 sm:p-4 ${className}`}
    >
      <span className="material-symbols-outlined text-[20px] text-on-surface-variant shrink-0" style={{ fontVariationSettings: "'FILL' 1" }}>lock</span>
      <p className="text-[12px] sm:text-[13px] font-medium text-on-surface-variant leading-snug">
        <span className="font-extrabold uppercase tracking-wider text-on-surface">Read-only</span>
        {' — '}you don't have the <span className="font-bold text-on-surface">{label}</span> permission.
        Ask the super admin to grant it.
      </p>
    </div>
  )
}

// Full-panel replacement for sections where even reads are blocked (403).
export function AccessRequired({ permission }) {
  const label = PERMISSION_LABELS[permission] ?? permission
  return (
    <div className="border-4 border-dashed border-on-background/25 bg-surface-container-low p-6 sm:p-10 flex flex-col items-center gap-3 text-center">
      <span className="material-symbols-outlined text-[36px] text-on-surface-variant/60">lock</span>
      <p className="font-extrabold text-[12px] sm:text-[13px] uppercase tracking-widest text-on-surface">Access required</p>
      <p className="text-[12px] sm:text-[13px] text-on-surface-variant max-w-[420px]">
        This area needs the <span className="font-bold text-on-surface">{label}</span> permission.
        Ask the super admin to grant you access.
      </p>
    </div>
  )
}

export function SuperAdminOnly({ what = 'This area' }) {
  return (
    <div className="border-4 border-dashed border-on-background/25 bg-surface-container-low p-6 flex items-center gap-3">
      <span className="material-symbols-outlined text-[24px] text-on-surface-variant/60 shrink-0">shield_lock</span>
      <p className="text-[12px] sm:text-[13px] text-on-surface-variant">
        <span className="font-bold text-on-surface">{what}</span> is only available to the super admin.
      </p>
    </div>
  )
}
